var exports = {
  "VA": "xa15a2ab7--24b5bc--subtitle",
  "LQ": "xa15a2ab7--24b5bc--rooms",
};

module.exports = exports;
